import productDetailPageSchema from './productDetailPage';

export default {
  product_detail: productDetailPageSchema,
};
